import React, { useEffect, useState } from 'react';
import DexView from '../../assets/dexview.webp';
import './Chart.css';

interface ChartProps {
  address: string;
  chain: string;
  theme?: string;
  chartType?: number;
  chartResolution?: number;
  drawingToolbars?: boolean;
  headerColor?: string;
  tvPlatformColor?: string;
  tvPaneColor?: string;
}

const Chart: React.FC<ChartProps> = ({
  address,
  chain,
  theme = "dark",
  chartType = 1,
  chartResolution = 30,
  drawingToolbars = false,
  headerColor = "111111",
  tvPlatformColor = "111111",
  tvPaneColor = "111111",
}) => {
  const [chainFormatted, setChainFormatted] = useState<string | null>(null);
  const [url, setURL] = useState<string | null>(null);

  // set chain
  useEffect(() => {
    if (!chain) return;
    const lowerChain = chain.toLowerCase();
    if (lowerChain === 'bsc') {
      setChainFormatted('bnb');
    } else if (lowerChain === 'eth') {
      setChainFormatted('ether');
    } else if (lowerChain === 'sol' || lowerChain === 'solana') {
      setChainFormatted('solana');
    } else if (lowerChain === 'base') {
      setChainFormatted('base');
    } else if (lowerChain === 'arbitrum') {
      setChainFormatted('arbitrum');
    } else if (lowerChain === 'polygon') {
      setChainFormatted('polygon');
    } else if (lowerChain === 'avax') {
      setChainFormatted('avalanche');
    } else {
      setChainFormatted(null);
    }
  }, [chain]);

  useEffect(() => {
    if (chainFormatted) {
      setURL(
        `https://www.dextools.io/widget-chart/en/${chainFormatted}/pe-light/${address}?theme=${theme}&chartType=${chartType}&chartResolution=${chartResolution}&drawingToolbars=${drawingToolbars}&headerColor=${headerColor}&tvPlatformColor=${tvPlatformColor}&tvPaneColor=${tvPaneColor}`
      );
    }
  }, [
    chainFormatted, 
    address, 
    theme, 
    chartType, 
    chartResolution, 
    drawingToolbars, 
    headerColor, 
    tvPlatformColor, 
    tvPaneColor
  ]);

  // If isListed, return either the iframe or fallback "No chart found"
  return url ? (
    <>
      <img className='dexview-overlay' src={DexView}></img>
      <iframe
        id="dextools-widget"
        height="600px"
        width="100%"
        src={url}
        style={{ border: "none" }}
      />
    </>
  ) : (
    <div>No chart found.</div>
  );
};

export default Chart;
